import {css} from 'lit'; export default css`:host{display:block;height:100%;overflow:hidden}.sds-sidebar .sds-sidebar__container{overflow-y:auto;height:calc(100% - 16px);padding:8px 16px}`;
    